import { api } from './api';

/**
 * Feedback item from the API
 */
export interface FeedbackItem {
  requestId: string;
  customerName: string;
  requestorName: string;
  requestorEmail: string;
  region: string;
  stage: string;
  fbRating: number | null;
  fbComments: string | null;
  sysModifiedOn: string;
  sysModifiedBy: string;
}

/**
 * Pagination parameters for feedback queries
 */
export interface FeedbackPaginationParams {
  page: number;
  pageSize: number;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
  searchText?: string;
  rating?: string;
  modifiedOn?: string;
}

/**
 * Paginated response structure
 */
export interface PaginatedFeedbackResponse {
  data: FeedbackItem[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

/**
 * Service for fetching feedback data via the API
 */
export class FeedbackService {
  /**
   * Fetch feedback with pagination and filters
   */
  static async getFeedbackPaginated(
    params: FeedbackPaginationParams,
  ): Promise<PaginatedFeedbackResponse> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      pageSize: params.pageSize.toString(),
    });

    if (params.orderBy) {
      queryParams.append('orderBy', params.orderBy);
    }

    if (params.orderDirection) {
      queryParams.append('orderDirection', params.orderDirection);
    }

    if (params.searchText) {
      queryParams.append('searchText', params.searchText);
    }

    if (params.rating) {
      queryParams.append('rating', params.rating);
    }

    if (params.modifiedOn) {
      queryParams.append('modifiedOn', params.modifiedOn);
    }

    return api.get<PaginatedFeedbackResponse>(`/feedback?${queryParams}`);
  }
}
